export const TYPESENSE_SERVER_CONFIG = {
  apiKey: process.env.NEXT_PUBLIC_TYPESENSE_SEARCH_API_KEY as string,
  nodes: [
    {
      host: process.env.NEXT_PUBLIC_TYPESENSE_HOST as string,
      port: parseInt(`${process.env.NEXT_PUBLIC_TYPESENSE_PORT ?? 443}`, 10),
      protocol: process.env.NEXT_PUBLIC_TYPESENSE_PROTOCOL as string,
    },
  ],
  cacheSearchResultsForSeconds: 2 * 60,
};
